import React from "react";

function Loading() {
  //write code here

  return (
    <div className="fa-3x">
      <i className="fas fa-sync fa-spin"></i>
    </div>
  );
}

export default Loading;
